import tab from './tab'
import modal from './modal'
import download from './download'
import cache from './cache'
export default {
  install(Vue) {
    // 页签操作
    Vue.prototype.$tab = tab
    // 模态框对象
    Vue.prototype.$modal = modal
    // 下载文件
    Vue.prototype.$download = download
    // 缓存对象
    Vue.prototype.$cache = cache
  }
}
